import get from "lodash/get";
import find from "lodash/find";
import { getUrl } from "./helpers";
import dayjs from "dayjs";

const graphUrl = `/breakdown-analysis`;
const dateFormat = "YYYY-MM-DD"

export const graphEventHandler = (event, selectedTemplate, stats, filter, type ) => {
        const selectedStat = get(event, "data.data");
        const idle = find(stats, (stat) => {
          return (
            get(stat, "date") === get(selectedStat, "date") &&
            get(stat, "type") === "IDLE"
          );
        });
        const off = find(stats, (stat) => {
          return (
            get(stat, "date") === get(selectedStat, "date") &&
            get(stat, "type") === "OFF"
          );
        });
           
        if (get(idle, "value") > 0 || get(off, "value")) {
          
          const url = getUrl(graphUrl, {
              company_uuid: get(selectedTemplate, "template.company.id"),
              template_type: get(selectedTemplate,"template.type.value"),
              template: get(selectedTemplate, "template.id"),
              interval:type ==="time"?"day":get(selectedTemplate, "interval"),
              from_date:type ==="time"?dayjs(get(filter,"date")).format(dateFormat):dayjs(get(selectedStat, "date")).format(dateFormat),
              to_date:type ==="time"?dayjs(get(filter,"date")).format(dateFormat):dayjs(get(selectedStat, "date")).format(dateFormat)
            });
            window.open(url, "_blank");
        }
      }